import { Injectable, Query } from '@nestjs/common';
import {   CommonResponseModel,  CartonBoxResponseModel, CartonBoxDto, CartonBoxActivateDeactivateDto } from '@project-management-system/shared-models';
import { DataSource, Not } from 'typeorm';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { CartonBoxRepository } from './repository/carton-box.repo';
import { CartonBoxAdapter } from './adapters/carton-box.adapter';
import { CartonBoxBDto } from './dto/carton-box-dto';
import { CartonBoxEntity } from './entity/carton-box.entity';

@Injectable()
export class CartonBoxService {
    constructor(
        private CartonRepo: CartonBoxRepository,
        private  adaptor: CartonBoxAdapter,

    ) { }
  
    async createCartonBox(req: CartonBoxBDto, isUpdate: boolean): Promise<CartonBoxResponseModel> {
        try {
            let findAllRecords: CartonBoxEntity[];
    
            if (!isUpdate) {
                findAllRecords = await this.CartonRepo.find();
            } else {
                findAllRecords = await this.CartonRepo.find({ where: { cartonBoxId: Not(req.cartonBoxId) } });
            }
    
            for (const records of findAllRecords) {
                if (records.style === req.style) {
                    throw new ErrorResponse(99999, 'Carton Box already existed');
                }
            }
    
            const adapterData = this.adaptor.convertDtoToEntity(req);
            if (isUpdate) {
                adapterData.cartonBoxId = req.cartonBoxId;
                adapterData.updatedUser = req.createdUser;
            } else {
                adapterData.createdUser = req.createdUser;
            }
    
            await this.CartonRepo.save(adapterData);
    
            return new CartonBoxResponseModel(true, 200, isUpdate ? 'Updated Successfully' : 'Created Successfully');
        } catch (err) {
            throw err;
        }
    }
    
    async getCartonBoxData(): Promise<CartonBoxResponseModel> {
        const data = await this.CartonRepo.find()
        const Data: CartonBoxDto[] = []
        for (const record of data) {
            const adapterData = this.adaptor.convertEntityToDto(record)
            Data.push(adapterData)
        }
        return new CartonBoxResponseModel(true, 1111, 'Data retreived', Data)
    }

    async getAllCartonBoxData(req?:any): Promise<CommonResponseModel> {
        let query =  ` select DISTINCT * from carton_box groupBy`
        const data = await this.CartonRepo.query(query)
        if (data.length) {
            return new CommonResponseModel(true, 1, 'data retrived', data)
        } else {
            return new CommonResponseModel(false, 0, 'error')
        }
    }

    async getActiveCartonBox(): Promise<CartonBoxResponseModel> {
        const data = await this.CartonRepo.find({ where: { isActive: true } })
        const activeStylesData: CartonBoxDto[] = []
        for (const record of data) {
            const adapterData = this.adaptor.convertEntityToDto(record)
            activeStylesData.push(adapterData)
        }
        return new CartonBoxResponseModel(true, 1111, 'Data retreived', activeStylesData)
    }

    async activateOrDeactivate(Req: CartonBoxActivateDeactivateDto): Promise<CartonBoxResponseModel> {
        try {
            const StyleExists = await this.getCartonBoxId(Req.cartonBoxId);
            if (StyleExists) {
                if (Req.versionFlag !== StyleExists.versionFlag) {
                    throw new CartonBoxResponseModel(false,10113, 'Someone updated the current Style information.Refresh and try again');
                } else {

                    const locationStatus = await this.CartonRepo.update(
                        { cartonBoxId: Req.cartonBoxId },
                        { isActive: Req.isActive, updatedUser: Req.updatedUser });

                    if (StyleExists.isActive) {
                        if (locationStatus.affected) {
                            const LocationResponse: CartonBoxResponseModel = new CartonBoxResponseModel(true, 10115, 'CartonBox is Deactivated successfully');
                            return LocationResponse;
                        } else {
                            throw new CartonBoxResponseModel(false,10111, 'CartonBox is already deactivated');
                        }
                    } else {
                        if (locationStatus.affected) {
                            const LocationResponse: CartonBoxResponseModel = new CartonBoxResponseModel(true, 10114, 'CartonBox is activated successfully');
                            return LocationResponse;
                        } else {
                            throw new CartonBoxResponseModel(false,10112, 'CartonBox is already activated');
                        }
                    }
                }
            } else {
                throw new CartonBoxResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async getCartonBoxId(cartonBoxId: number): Promise<CartonBoxEntity> {
        const Response = await this.CartonRepo.findOne({
            where: { cartonBoxId: cartonBoxId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

}
